<template>
  <div class="languages">
    <PageHeading title="Sprachen" />
    <div v-for="language in languages" :key="language.code">
      <h2>{{ language.name }}</h2>
      <div v-for="link in language.links" :key="link.path">
        <NuxtLink :to="link.path">
          {{ link.title }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

import { type TranslationsQuery, type PageTranslationFragment } from '#graphql-operations'

const appConfig = useAppConfig()

const languages = ref([])

const { data } = await useAsyncData('translations', async () => {
  return await useGraphqlQuery('translations', { limit: 100 }).then((v) => {
    const result: TranslationsQuery = v.data
    return result.translations
  })
})

const items: PageTranslationFragment[] = data.value?.items

appConfig.languages.forEach((language) => {
  if (language.code === 'de') {
    return
  }
  const languageData = {
    ...language,
    links: getLanguageLinks(language.code)
  }
  languages.value.push(languageData)
})

function getLanguageLinks (langcode: string): array {
  const links = []

  items.forEach((item) => {
    const translation = item?.translations.find((translation) => {
      return translation.langcode === langcode
    })
    if (translation !== undefined) {
      links.push({
        title: translation.title,
        path: getTranslatedPath(item.path.alias, langcode)
      })
    }
  })
  return links
}

function getTranslatedPath (path: string, langcode: string): string {
  return `${path}?language=${langcode}`
}

useSeoMeta({
  title: 'Sprachen'
})

</script>
